import React from 'react';
import About from '../components/About';
import Marquee from '../components/Marquee';
import Reviews from '../components/Reviews';

function AboutPage() {
  return (
    <>
      <About />
      <Marquee />
      <Reviews />
    </>
  );
}

export default AboutPage;